import type { ObjectMetadata } from '@olytic/foundation';

import { OBJECT_DEFS } from '../../objects/objectDefs';
import { asDateTime, asLabel, field, lastModifiedByField, lookup, type Row, text } from './kit';

const def = OBJECT_DEFS['deal-retros'];

/** Why a deal was won or lost, in one person's words. Rationale: deal-retros.md. */
export const dealRetros: ObjectMetadata<Row> = {
  key: def.key,
  singular: 'Deal Retro',
  plural: def.label,
  icon: def.icon,
  listColumns: def.columns,
  details: [
    field('opportunity_name', 'Opportunity', { link: lookup('opportunities', 'opportunity_id') }),
    field('stage', 'Stage', { format: asLabel }),
    field('notes', 'Notes', { wide: true }),
    field('created_by_name', 'Created by'),
    field('created_at', 'Created', { format: asDateTime }),
    field('updated_at', 'Last Modified', { format: asDateTime }),
    lastModifiedByField(),
  ],
  sections: [
    { key: 'identity', fields: ['opportunity_name', 'stage', 'notes'] },
    { key: 'system', label: 'System', collapsed: true, fields: ['created_by_name', 'created_at', 'updated_at', 'last_modified_by_name'] },
  ],
  related: [],
  titleOf: (row) => text(row.name),
  searchKeys: ['name', 'opportunity_name', 'notes'],
};
